var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F38D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2674 11.4982H7.4509C7.3259 11.4982 7.22461 11.5995 7.22461 11.7245V20.7728C7.22461 20.8978 7.3259 20.9991 7.4509 20.9991H10.2674C10.3924 20.9991 10.4937 20.8978 10.4937 20.7728V11.7245C10.4937 11.5995 10.3924 11.4982 10.2674 11.4982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85856 7C7.83374 7 7 7.83284 7 8.85652C7 9.88067 7.83374 10.7138 8.85856 10.7138C9.88257 10.7138 10.7156 9.88062 10.7156 8.85652C10.7157 7.83284 9.88257 7 8.85856 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4293 11.2734C16.298 11.2734 15.4618 11.7597 14.9546 12.3123V11.7246C14.9546 11.5997 14.8533 11.4983 14.7283 11.4983H12.031C11.906 11.4983 11.8047 11.5997 11.8047 11.7246V20.7729C11.8047 20.8979 11.906 20.9992 12.031 20.9992H14.8414C14.9664 20.9992 15.0676 20.8979 15.0676 20.7729V16.2961C15.0676 14.7875 15.4774 14.1998 16.529 14.1998C17.6743 14.1998 17.7653 15.142 17.7653 16.3737V20.773C17.7653 20.898 17.8666 20.9993 17.9916 20.9993H20.803C20.9281 20.9993 21.0293 20.898 21.0293 20.773V15.8098C21.0293 13.5666 20.6016 11.2734 17.4293 11.2734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube);
export default __webpack_public_path__ + "static/media/logo_youtube.2aa71aeca6dacf59276065d919f3a092.svg";
export { ForwardRef as ReactComponent };